module.exports = __webpack_public_path__ + "media/fuzion-2.37b5a5f8.mp4";